/** floating-ui offset(mainAxis) the platform Dropdown puts between anchor and menu. */
const MENU_ANCHOR_OFFSET = 4;
/**
 * Vertical chrome of the platform StyledMenuList AROUND the menu content the
 * clamp is applied to: 8px padding + 1px border, top and bottom (the menu
 * container grows by this much beyond the clamped content).
 */
const MENU_CONTAINER_CHROME = 18;
/** Breathing room kept between the menu's bottom edge and the viewport edge. */
const VIEWPORT_PADDING = 8;
/**
 * Below this the menu is unusable anyway — an anchor this close to the viewport
 * bottom (never the case for a header row in practice) keeps a readable menu at
 * the cost of slight overflow instead of collapsing to a sliver.
 */
const MIN_MENU_HEIGHT = 100;

/**
 * Max height for the column header menu so it never runs past the viewport
 * bottom (T20-136597). The menu always opens BELOW its anchor — the grid
 * boundary starts at the header row, so floating-ui's flip() has no space
 * above to use — which makes "viewport height minus anchor bottom" the exact
 * available space. Measured at open time in the trigger's event handler; both
 * trigger paths (hover-button Dropdown and right-click openDropdown) pass the
 * result to ColumnHeaderMenu, which scrolls internally past it.
 *
 * @param anchorBottom clientY of the anchor's bottom edge — the trigger
 *   button's rect bottom, or the cursor Y for the right-click (cursor) path.
 */
export function getColumnMenuMaxHeight(anchorBottom: number): number {
  return Math.max(
    window.innerHeight -
      anchorBottom -
      MENU_ANCHOR_OFFSET -
      MENU_CONTAINER_CHROME -
      VIEWPORT_PADDING,
    MIN_MENU_HEIGHT
  );
}
